import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { nameEntryMode } from "./individualName";
export default function useNameEntryMode(orgId) {
  const [state, setState] = useState({ orgId: "", mode: "full", ready: false });
  useEffect(() => {
    if (!orgId) return undefined;
    return onSnapshot(doc(db, "orgs", orgId), snapshot => setState({ orgId, mode: nameEntryMode(snapshot.data()?.nameEntryMode), ready: true }),
      () => setState({ orgId, mode: "full", ready: false }));
  }, [orgId]);
  return state.orgId === orgId ? state : { mode: "full", ready: false };
}
